import React from 'react';

import { useTournamentState } from '@atlas/core';
import { TournamentBreadcrumbSkeleton } from '@atlas/ui';

const TournamentHeaderLoader = ({ children }) => {
  const { initialized, loading } = useTournamentState();

  if (!initialized && loading) {
    return (
      <div className="tournament-page-header">
        <TournamentBreadcrumbSkeleton />
      </div>
    );
  }

  return children;
};

export default TournamentHeaderLoader;
